import type { SchemaEntry } from '../create-field-schema-registry';
import email from './email';
import name from './name';
import phoneNumber from './phone-number';

export default [email, name, phoneNumber] as const satisfies ReadonlyArray<SchemaEntry>;
